import React, { useState, useEffect, useRef } from 'react';
import { Redirect, useLocation, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet'

import Sidebar from '../partials/Sidebar';
import Header from '../partials/Header';
import AlertModal from '../partials/AlertModal'
import WebPushSidebar from '../partials/webpush/WebPushSidebar';
import WebPushProfile from '../partials/webpush/WebPushProfile';
import WebPushCreate from '../partials/webpush/WebPushCreate';

import { Auth, API, graphqlOperation } from 'aws-amplify';

function WebPush() {

  const location = useLocation()
  const history = useHistory()
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [ userDetails, setUserDetails ] = useState(null)
  const [ authToken, setAuthToken ] = useState(null)

  const [selectedWebPushOption, setSelectedWebPushOption] = useState('PUSH_CREATE');

  useEffect(() => {
    OnLoad();
  }, []);

  function logout(){
    try {
      Auth.signOut().then(() => {
        history.push('/signin')
      })
    } catch (error) {
      history.push('/signin')
    }
  }

  function OnLoad() {
    Auth.currentSession().then(response => {
      setAuthToken(response.idToken.jwtToken)
    }).catch( (error) => {
      history.push('/signin')
    });
    if(location!=null) {
      if(location.state==null) {
        history.push('/signin')
      }
      else{
        setUserDetails(location.state.userDetails)
      }
    }
    else {
      history.push('/signin')
    }
  }

  return userDetails!=null?(
    <div className="flex h-screen overflow-hidden striped-background-pattern">
      {/* Page Title */}
      <Helmet>
        <title>EmPushy | Web Push</title>
      </Helmet>
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} userDetails={userDetails}/>

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">

        {/*  Site header */}
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} userDetails={userDetails}/>

        <main>
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">

            {/* Page header */}
            <div className="mb-8">
              {/* Title */}
              <h1 className="text-2xl md:text-3xl text-gray-800 font-bold">Web Push 🔔</h1>
            </div>

            {/* Content */}
            <div className="bg-white rounded-sm mb-8">
              <div className="flex flex-col md:flex-row md:-mr-px">
                <WebPushSidebar selectedWebPushOption={selectedWebPushOption} toggleWebPushOption={setSelectedWebPushOption}/>
                {selectedWebPushOption=='PUSH_CREATE'?<WebPushCreate userDetails={userDetails} authToken={authToken} logout={logout}/>:
                  selectedWebPushOption=="SUBSCRIBE_MY_PROFILE"?<WebPushProfile userDetails={userDetails} authToken={authToken} logout={logout}/>:<div className="m-auto p-4">Feature coming soon.</div>}
              </div>
            </div>

          </div>
        </main>

      </div>

    </div>
  ):'';
}

export default WebPush;